/**
 * Display names for the CV templates.
 *
 * The backend stores canonical English names in HTML_TEMPLATES_CONFIG.
 * This map localizes them so the landing strip and the in-app gallery
 * always show the same wording in the user's language.
 */

const ES_NAMES = {
  // Modern
  'Premium Dark': 'Oscura Premium',
  'Futuristic Tech': 'Tecnológica Futurista',
  'Tokyo Night': 'Tokio Noche',
  'Silicon Valley': 'Startup Tecnológica',
  'Gradient Flow': 'Degradado Fluido',
  // Classic
  'Elegant Classic': 'Clásica Elegante',
  'Luxury Executive': 'Ejecutiva de Lujo',
  'Parisian Chic': 'Chic Parisina',
  'Art Deco Luxe': 'Art Déco',
  'Oxford Academic': 'Académica Oxford',
  // Creative
  'Creative Modernist': 'Modernista Creativa',
  'Swiss Design': 'Diseño Suizo',
  'Portfolio Artist': 'Portafolio Artístico',
  'Bold Statement': 'Impacto Rotundo',
  // Minimal
  'Minimalist Luxury': 'Minimalista de Lujo',
  'Nordic Minimal': 'Nórdica Minimalista',
  'Paper White': 'Papel Blanco',
  'Mono Space': 'Monoespaciada',
};

/**
 * Return the template name in the requested language.
 *
 * @param {string} name - Canonical (English) template name.
 * @param {string} lang - UI language code ('es' or 'en').
 * @returns {string} Localized name, or the canonical one when untranslated.
 */
export const getTemplateDisplayName = (name, lang) => {
  if (lang !== 'es') {
    return name;
  }
  return ES_NAMES[name] || name;
};

export default getTemplateDisplayName;
